'use client';
import { Disclosure, Transition } from '@headlessui/react';
import { Minus, Plus } from 'lucide-react';
import { ReactNode } from 'react';

const SidebarSection = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  return (
    <Disclosure defaultOpen={true}>
      {({ open }) => (
        <div className="border-b border-black/10">
          <Disclosure.Button className="flex w-full justify-between py-4 text-left font-medium">
            <span>{title}</span>
            {!open ? (
              <Plus className="h-5 w-5 text-gray-500" />
            ) : (
              <Minus className="h-5 w-5 text-gray-500" />
            )}
          </Disclosure.Button>
          <Transition
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <Disclosure.Panel className="pt-4 pb-2 text-sm max-h-[480px] overflow-y-auto">
              {children}
            </Disclosure.Panel>
          </Transition>
        </div>
      )}
    </Disclosure>
  );
};

export default SidebarSection;
